<template>
  <div>
    <ts-loading-banner :loading="loading">
      <table class="ts-table ts-w-full">
        <template v-for="(resource, index) in resources">
          <tr>
            <td class="ts-pr-2 ts-cursor-pointer ts-pt-1 ts-pb-1 ts-w-4">
              <div @click="toggleExpend(index)">
                <i class="far fa-plus-square" v-if="!expandableItems[index]"></i>
                <i class="fas fa-minus" v-else></i>
              </div>
            </td>
            <td>
              <strong>{{ startCase(index) }}</strong>
            </td>
          </tr>
          <tr v-if="expandableItems[index]" class="ts-border-t ts-border-b">
            <td></td>
            <td class="ts-pt-1 ts-pb-1">
              <div style="width:500px">
                <table class="ts-w-full">
                  <thead>
                    <tr>
                      <th
                        class="ts-uppercase ts-bg-gray-100 ts-px-2 ts-py-1 ts-rounded-tl ts-rounded-bl"
                      >
                        Warehouse
                      </th>
                      <th
                        class="ts-uppercase ts-bg-gray-100 ts-px-2 ts-py-1 ts-rounded-tr ts-rounded-br ts-text-center"
                      >
                        Qty
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="ts-border-t"
                      v-for="(item, itemIndex) in resource"
                      :key="itemIndex"
                    >
                      <td class="ts-px-2 ts-py-1">{{ item.location_name_en }}</td>
                      <td class="ts-px-2 ts-py-1 ts-text-center">
                        {{ item.quantity }}
                      </td>
                    </tr>
                    <tr class="ts-bg-blue-100 ts-tex-white">
                      <td class="ts-px-2 ts-py-1"><strong>Total:</strong></td>
                      <td class="ts-px-2 ts-py-1 ts-text-center"> {{ $formatNumber(sumBy(resource, 'quantity'), 0) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </table>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { startCase, sumBy } from 'lodash'
export default {
  name: 'summaryTable',
  data() {
    return {
      loading: false,
      expandableItems: {},
      resources: []
    }
  },
  computed: {
    sumBy: () => (resource, column) =>  {
      return sumBy(resource, column)
    }
  },
  methods: {
    ...mapActions('product/productDetail', ['fetch']),
    startCase,
    fetchData() {
      this.loading = true
      this.fetch(this.$route.params.id)
        .then(response => {
          this.resources = response.data
          Object.keys(this.resources).forEach(index => {
            this.expandableItems[index] = false
          })
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    toggleExpend(index) {
      this.expandableItems[index] = !this.expandableItems[index]
      this.$nextTick(() => this.$forceUpdate())
    }
  }
}
</script>
